import { createSelector } from '@reduxjs/toolkit';
import { createSelectorCreator, defaultMemoize } from 'reselect';

import { VisualAppState } from '../../reducer';
import { serializeFilters } from './utils';

const createValueSelector = createSelectorCreator(defaultMemoize, (item1, item2) => (
  JSON.stringify(item1) === JSON.stringify(item2)
));

export const globalState = (state: VisualAppState) => state;
export const location = (state: VisualAppState) => state.router.location;
export const filterRoot = (state: VisualAppState) => state.apps.visual.buildDetailsFilterBar;
export const getSearchParams = createSelector(filterRoot, (state) => (
  JSON.stringify(serializeFilters(state))
));
export const buildDetailsFilterInitState = createSelector(filterRoot, (state) => state.init);
export const buildDetailsFilterBar = createSelector(filterRoot, (state) => state);

const getOtherFilters = createSelector(buildDetailsFilterBar, (state) => ({
  os: state.os.value,
  browser: state.browser.value,
  status: state.status.value,
  device: state.device.value,
  groupBy: state.groupBy.value,
}));
const getSearch = createSelector(buildDetailsFilterBar, (state) => state.search.searchValue);

export const buildDetailsFilterValues = createValueSelector([
  getOtherFilters,
  getSearch,
], (filters, search) => ({
  ...filters,
  search,
}));
